import { render, staticRenderFns } from "./_totalProductShortages.vue?vue&type=template&id=5b3621a0&scoped=true&"
import script from "./_totalProductShortages.vue?vue&type=script&lang=js&"
export * from "./_totalProductShortages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3621a0",
  null
  
)

export default component.exports